const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8787';

const authHeaders = (token) => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${token}`
});

export const fetchApi = async (path, method = 'GET', body, token) => {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: authHeaders(token),
    body: body ? JSON.stringify(body) : undefined
  });

  if (!res.ok) {
    const payload = await res.json().catch(() => ({}));
    throw new Error(payload.error || payload.message || 'API request failed');
  }
  return res.json();
};

// -------------------- POSTS / FEED --------------------
export const getPosts = (token, page = 1, limit = 10) => 
  fetchApi(`/api/posts?page=${page}&limit=${limit}`, 'GET', null, token);

export const createPost = (postData, token) => 
  fetchApi('/api/posts', 'POST', postData, token);

export const likePost = (postId, token) => 
  fetchApi(`/api/posts/${postId}/like`, 'POST', null, token);

export const commentOnPost = (postId, content, token) => 
  fetchApi(`/api/posts/${postId}/comments`, 'POST', { content }, token);

// -------------------- CONTESTS --------------------
export const getActiveContests = (token) => 
  fetchApi('/api/contests/active', 'GET', null, token);

export const getContests = (token) => 
  fetchApi('/api/contests', 'GET', null, token);

export const getContestDetails = (contestId, token) => 
  fetchApi(`/api/contests/${contestId}`, 'GET', null, token);

export const enterContest = (contestId, mediaBase64, token) => 
  fetchApi(`/api/contests/${contestId}/enter`, 'POST', { mediaBase64 }, token);

export const voteContest = (contestId, contestantId, token) => 
  fetchApi(`/api/contests/${contestId}/vote`, 'POST', { contestantId }, token);

// Vote submission (receipt)
export const submitVote = (contestantId, receiptBase64, token) => 
  fetchApi('/api/votes/submit', 'POST', { contestantId, receiptBase64 }, token);

// Admin: Create contest
export const createContest = (contestData, token) => 
  fetchApi('/api/contests', 'POST', contestData, token);

// -------------------- SUPER ADMIN QUEUE --------------------
export const getPendingVotes = (token) => 
  fetchApi('/api/votes/pending', 'GET', null, token);

export const verifyVote = (pendingVoteId, approve, adminNotes, token) => 
  fetchApi('/api/votes/verify', 'POST', { pendingVoteId, approve, adminNotes }, token);

// -------------------- QUIZ --------------------
export const getQuizSessions = (token) => 
  fetchApi('/api/quiz/sessions', 'GET', null, token);

export const createQuizSession = (title, token) => 
  fetchApi('/api/quiz/sessions', 'POST', { title }, token);

export const getQuizSessionDetails = (sessionId, token) => 
  fetchApi(`/api/quiz/sessions/${sessionId}`, 'GET', null, token);

export const joinQuizSession = (sessionId, token) => 
  fetchApi(`/api/quiz/sessions/${sessionId}/join`, 'POST', {}, token);

export const answerQuizQuestion = (sessionId, questionId, answer, token) => 
  fetchApi(`/api/quiz/sessions/${sessionId}/answer`, 'POST', { questionId, answer }, token);

// -------------------- DELETE POST--------------------
export const deletePost = (postId, token) => 
  fetchApi(`/api/posts/${postId}`, 'DELETE', null, token);

// Note: WebSocket connection for quiz chat is separate (not via fetchApi)
// You'll create a WebSocket instance using `new WebSocket()` with the URL.

// -------------------- MEDIA UPLOAD (CLOUDINARY) --------------------
// Direct Cloudinary upload for faster media handling
import { uploadToCloudinary } from './cloudinary';

export const uploadMediaToCloudinary = async (file) => {
  try {
    return await uploadToCloudinary(file);
  } catch (error) {
    console.error('Media upload failed:', error);
    throw error;
  }
};

// Legacy: Media upload via backend (if needed)
export const uploadMedia = (mediaBase64, token) => 
  fetchApi('/api/media/upload', 'POST', { mediaBase64 }, token);